module.exports = __webpack_public_path__ + "img/figure.4e83b3a1.png";